






















export default {
    props: {
        title: { type: String, default: "down arrow icon" },
        fill: { type: String, default: "currentColor" },
        secondaryfill: { type: String }
    }
};
